import styled from "styled-components";

export const DetailsWrap = styled.div`

`
export const Icon = styled.svg`
    fill: #b9b9b9;
    align-self: center;
    transition: all 0.2s;
`
export const ArrowIcon = styled.svg`
    position: absolute;
    top: 50%;
    transform: translateY(-50%) ${({$open})=>$open ? `rotate(90deg)` : ''};
    right: 15px;
    transition: all 0.2s;
    display: block;
    @media screen and (max-width: 767px){
        display: none;
    }
`
export const SummaryButton = styled.button`
    position: relative;
    padding: 9px 30px 12px 15px;
    color: #222;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    background-color: #fdfdfd;
    text-transform: uppercase;
    outline: none;
    border: #ececec 1px solid;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    width: 100%;
    transition: all 0.2s;
    box-sizing: border-box;
    &:hover {
        background-color: #f8f8f8;
    ${Icon}{
            fill:#868686;
        }
    }
`;
export const DetailsContent = styled.div`
    overflow: hidden;
    padding: ${({ $open }) => ($open ? " 20px" : "0 20px")};
    box-sizing: border-box;
    max-height: ${({ $open }) => ($open ? "1000px" : "0")};
    transition: all 300ms ease-in-out;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border:${({ $open }) => ($open ? " #ececec 1px solid" : "#ececec 0px solid")};
`;

